import { toNumber } from "@/utils/number";

export const API_SUCCESS_MESSAGE = "保存しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー";
export const PREVENT_URL = "不適切なURLです";
export const DEFAULT_TIMER = 1000;
export const INVALID_MUST_AFTER_DATE = "「{{end}}」は「{{start}}」より後にする必要があります";
export const MAX_INTEGER = 2147483646;
export const MAX_INTEGER_INPUT_VALIDATION = 10;
export const PASSWORD_CHANGE_SUCCESS_MESSAGE = "パスワードが再設定されました。";
export const RESEND_EMAIL_MINUTES = 5;
export const RESEND_EMAIL_RATE_LIMIT_MS = RESEND_EMAIL_MINUTES * 60 * 1000; // 5 min
export const RESEND_EMAIL_LOCALSTORAGE_KEY = "last-reset-password-request-time";
export const RESEND_EMAIL_BLOCKED_MESSAGE = `リセットメールは${RESEND_EMAIL_MINUTES}分以内に1回のみ送信できます。しばらくしてから再度お試しください。`;
export const MAX_NAME_INPUT_VALIDATION = 26;
export const MAX_EMAIL_INPUT_VALIDATION = 60;
export const MAX_PASSWORD_INPUT_VALIDATION = 64;
export const AUTH_COOKIE_EXPIRES_DAYS = toNumber(process.env.REACT_APP_AUTH_COOKIE_EXPIRES_DAYS) || 30;
